import { render } from "./CustomerZones.vue?vue&type=template&id=0d229a1e&ts=true"
import script from "./CustomerZones.ts?vue&type=script&lang=ts"
export * from "./CustomerZones.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__